import { monitorValue } from "../../util/monitorUtils";

const buildTractionData = (monitor) => {

    const result = {};

    const groupA = [1, 4, 5, 8];
    const groupB = [2, 3, 6, 7];

    for (let car = 1; car <= 8; car++) {

        if (groupA.includes(car)) {

            result[car] = [

                { label: "\u00A0", active: false },

                { label: "\u00A0", active: false },

                { label: "\u00A0", active: false },

                {
                    label: "DISJ. AUX. ABERTO",

                    active:
                        monitorValue(
                            monitor,
                            `disjuntorAuxiliarAbertoCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `disjuntorAuxiliarAbertoCarro${car}`
                        ]?.category
                },

                {
                    label: "FALHA NA APLICAÇÃO DO FREIO",

                    active:
                        monitorValue(
                            monitor,
                            `falhaAplicacaoFreioCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `falhaAplicacaoFreioCarro${car}`
                        ]?.category
                },
                {
                    label: "TRAÇÃO\nINOPERANTE",

                    active:
                        monitorValue(
                            monitor,
                            `tracaoInoperanteCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `tracaoInoperanteCarro${car}`
                        ]?.category
                },


            ];
        }

        if (groupB.includes(car)) {

            result[car] = [

                {
                    label: "CVS NÃO\nOPERACIONAL",

                    active:
                        monitorValue(
                            monitor,
                            `cvsNaoOperacionalCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `cvsNaoOperacionalCarro${car}`
                        ]?.category
                },

                {
                    label: "RESET DE CVS",

                    active:
                        monitorValue(
                            monitor,
                            `resetCvsCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `resetCvsCarro${car}`
                        ]?.category
                },

                {
                    label: "CVS EM FALHA",

                    active:
                        monitorValue(
                            monitor,
                            `cvsFalhaCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `cvsFalhaCarro${car}`
                        ]?.category
                },

                {
                    label: "DISJ. AUX. ABERTO",

                    active:
                        monitorValue(
                            monitor,
                            `disjuntorAuxiliarAbertoCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `disjuntorAuxiliarAbertoCarro${car}`
                        ]?.category
                },

                {
                    label: "FALHA NA APLICAÇÃO DO FREIO",

                    active:
                        monitorValue(
                            monitor,
                            `falhaAplicacaoFreioCarro${car}`,
                            0
                        ) !== 0,

                    category:
                        monitor?.[
                            `falhaAplicacaoFreioCarro${car}`
                        ]?.category
                },

                { label: "\u00A0", active: false }
            ];
        }
    }

    return result;
};

export default buildTractionData;